import { Injectable } from '@angular/core';
import { SnackbarComponent } from '../common/snackbar/snackbar.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Storage } from '@ionic/storage';
import * as fileSaver from 'file-saver';
import { EmailPattern } from 'src/app/constants';
import { ConnectionService } from './connection.service';
import { AlertWindowComponent } from '../common/alert-window/alert-window.component';
import { MatSnackBarConfig, MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
@Injectable({
  providedIn: 'root'
})
export class DataService {
  emailPattern = EmailPattern;
  configSuccess: MatSnackBarConfig = {
    duration: 5000,
    horizontalPosition: 'center',
    verticalPosition: 'top',
    panelClass: ''
  };
  // apiUrl = 'https://ecbill.net/ecbill_web_live/';
  apiUrl = 'https://ecbill.net/ecbill_web_alpha/';
  token = '';
  tempToken = '';
  fycode = '';
  brcode = '';
  edcode = '1';
  btnClicked = false;
  preloadTrue = false;
  companylogoTrue = false;
  companyLogo: any;
  saleorderreport = false;
  salesgoodsissue = false;
  productionorderreport = false;
  poreport = false;
  workorderreport = false;
  printPreview = [];
  printPreviewDetails = {
    'actiondate': '',
    'refno': '',
    'formname': '',
    'actiontype': '',
    'username': ''
  }
  selectedBranch = {
    branchcode: '',
    countercode: '',
  }
  decimalvariable = '2';
  pdfmsg: any = '';
  authorizationResponse = {
    usercode: '',
    salespersonname: '',
    username: '',
    branchcode: '',
    salespersoncode: '',
    type: '',
    typename: '',
    registered: '',
    ratechangeallowed: '',
    salesdiscountallowed: '',
    discountpercentupto: '',
    salesdeleteallowed: '',
    salespersonmandatory: '',
    dayoverrequired: '',
    showdayoverfirst: '',
    closedayupto: '',
    companycode: '',
    companyname: '',
    branchname: '',
    finyear: '',
    finyearautoload: '',
    counters: [],
    temptoken: '',
    showregionalname: '',
    showbalancetopayscreen: '',
    itemdiscountallowed: '',
    showdob: '',
    dobmandatory: '',
    showdow: '',
    dowmandatory: '',
    instantsearchrequired: '',
    instantsearchlength: '',
    noofitemsonsearch: '',
    branches: [],
    rights: [],
    webposallowed: '',
    softwaresetup: {
      data: {
        quantitypricecolumns: {
          saleraterequired: '',
          dealerraterequired: '',
          price1required: '',
          price2required: '',
          price3required: '',
          price4required: '',
          price5required: '',
          price6required: ''
        },
        branchtransferratefrommrpprofit: '',
        branchwisepricing: '',
        batchconceptsyn: '',
        quantitybasedsetup: '',
        autorateupdateonpurchase: '',
        allowissuemorethanbom:'',
        multigrouplevel: '',
        branchwiseitem: '',
        multibarcodeonitem: '',
        instantsearchlength: '',
        singlewindowmatrixsearch: '',
        indentrequired: '',
        multicurrencyonpurchase: '',
        multicurrencyonsales: '',
        salespersonrequired: '',
        salespersonentrytype: '',
        costcenterrequired: '',
        smsattachmentlinktype: '',
        showcustomerdob: '',
        showcustomerdow: '',
        customerdobmust: '',
        customerdowmust: '',
        allreceiptmodes: [],
        selectedreceiptmodes: [],
        directpurchaseallowed: '',
        pobasedpurchaseallowed: '',
        goodsinwardreq: '',
        inwardinspectionreq: '',
        godowntransferreq: '',
        productconversionreq: '',
        smsviawhatsapp: '',
        directgrnallowed: '',
        pobasedgrnallowed: '',
        inv_on_purchase: '',
        inv_on_grn: '',
        salesno_gentype_code: '',
        salesno_gentype_name: '',
        entrywise_contact_mandatory: '',
        default_receipt_mode: '',
        directsalesallowed: '',
        quotation_based_sales: '',
        order_based_sales: '',
        dc_based_sales: '',
        allowmultipoinward_to_purchase: '',
        allowmultioadc_to_sales: '',
        integrateeinvoice: '',
        integrateewaybill: '',
        ewaybill_thresholdlimitfor_code: '',
        ewaybill_thresholdlimitfor_name: '',
        intrastate_ewaybillyn: '',
        intrastateewaybill_thresholdlimit: '',
        interstateewaybill_thresholdlimit: '',
        salesorder_number_automatic_generation: '',
        dc_number_automatic_generation: '',
        receipt_number_automatic_generation: '',
        sales_number_automatic_generation: '',
        suppid_automatic_generation: '',
        suppautoid_generation_type: '',
        suppautoid_prefix: '',
        suppautoid_number: '',
        suppautoid_formatdigits: '',
        custid_automatic_generation: '',
        custautoid_generation_type: '',
        custautoid_prefix: '',
        custautoid_number: '',
        custautoid_formatdigits: '',
        productid_automatic_generation: '',
        productautoid_generation_type: '',
        productautoid_prefix: '',
        productautoid_number: '',
        productautoid_formatdigits: '',
        productautoid_skip_number: '',
        quotno_generation_type: '',
        quot_mandatory_for_oa: '',
        custorderno_mand_onsales: '',
        default_search_method: '',
        notes_mand_onpo_withoutindent: '',
        batchno_takenfrom_prevpurchase: '',
        duplicate_custpono_allow_in_oa: '',
        duplicate_suppquotno_allow_in_po: '',
        default_inclusivetax_on_customer: '',
        restrict_space_in_id: '',
        upper_conversion_req: '',
        sendsms_alwaystrue_oncust: '',
        sendemail_alwaystrue_oncust: '',
        masterprice_req_bydefault_onproduct: '',
        autorateupdate_req_bydefault_onproduct: '',
        rewardcalc_req_on_cust_bydefault: '',
        billvalue_zero_dontallow_onsales: '',
        zerostk_display_on_productsearch: '',
        cursor_focus_on_id: '',
        dontallow_expirylessthan_item: '',
        expiry_lessthan_days: '',
        sales_disc_req_on_pur: '',
        barcode_usein_purchase: '',
        salesdisc_tobe_takenfrom: '',
        productsearch_basedon_barcode_onsales: '',
        alertpayment_on_materialrejection: '',
        prratechange_alert_req_onpur: '',
        suppratechange_alert_req_onpur: '',
        maxstockalertonpurchase: '',
        minstockalertonsales: '',
        minmaxstocksmsalert: '',
        minmaxstockemailalert: '',
        restore_previous_sales_item_details: '',
        showsupplieronproduct: '',
        showcustinfoonpurchase: '',
        salessmsalertperiodically: '',
        salessmsalertperiodicalinterval: '',
        salessmsalertperiodicallymobileno: '',
        salesemailalertperiodically: '',
        salesemailalertperiodicalinterval: '',
        salesemailalertperiodicallymailid: '',
        serialno_generation_type: '',
        serialno_generation_typename: '',
        productionorderreq: '',
        fgerequired: '',
        mrnrequired: '',
        fgirequired: '',
        workorderreq: '',
        goodsissuereq: '',
        maxfilesizeinmb: '',
        datewise_accountlock: '',
        accountlock_date: '',
        drawingdetailynonbom:'',
        itemnamedupallowed: ''
      }
    },
    edition_features: {
      approval_systems: '',
      batch_stocks_management: '',
      branchstocktransfer: '',
      brs_management: '',
      contra: '',
      cost_center_management: '',
      counter_management: '',
      coupen_management: '',
      adcoupen_managementd: '',
      credit_note: '',
      customer_loyalities: '',
      customerdc: '',
      customerwise_pricing: '',
      debit_note: '',
      freeoffer: '',
      godowntransfer: '',
      goodsissue: '',
      indent: '',
      inward: '',
      inward_inspection: '',
      journal: '',
      ledger_opening_balance: '',
      matrix_stocks_management: '',
      multicurrency_management: '',
      multiwarehouses: '',
      openingstocks: '',
      party_opening_bills: '',
      payments: '',
      pdc: '',
      po: '',
      productconversion: '',
      purchase: '',
      purchasereturn: '',
      quotation: '',
      receipts: '',
      sales_acknowledgement: '',
      sales_invoice: '',
      sales_pos: '',
      sales_target_management: '',
      salesexchange: '',
      salesorder: '',
      salesreturn: '',
      serial_stocks_management: '',
      sms_and_email_communications: '',
      stock_audit_checking: '',
      stock_release: '',
      supplierdc: '',
      tally_export: '',
      tcs_collections: '',
      useraccess_and_rightscontrols: '',
      wastage: '',
      production: ''
    },
    companysetup: {
      companytaxtype: '',
      timeformat24hr: '',
      amountdecimalplaces: '',
      countrycode: '',
      statecode: '',
      companycurrencyid: '',
      companycurrencycode: '',
      mrpconceptrequired: '',
      regionalfontname: ''
    },
    usersetup: {
      salesdeleteallowed: '',
      salesdiscountallowed: '',
      salesreprintallowed: '',
      salesupdateallowed: '',
      discountpercentupto: '',
      margincalconitem: '',
      userbillmode: '',
      showsettings: '',
      ratechangeallowed: '',
      itemdiscountallowed: '',
      viewactivites: ''
    },
    singlebranch: '',
    branchwisesetup: {
      multigodownrequired: '',
      dayoverprocessrequired: ''
    },
    approvalrequired: '',
    totalbranchcount: ''
  };
  authorizationkey = {
    token: '',
    branchwisesetup: {
      multigodownrequired: '',
      dayoverprocessrequired: ''
    }
  };
  matrices = {
    matrix1: { caption: '', required: '' },
    matrix2: { caption: '', required: '' },
    matrix3: { caption: '', required: '' },
    matrix4: { caption: '', required: '' },
    matrix5: { caption: '', required: '' },
    matrix6: { caption: '', required: '' },
    matrix7: { caption: '', required: '' },
    matrix8: { caption: '', required: '' },
    matrix9: { caption: '', required: '' },
    matrix10: { caption: '', required: '' },
  }

  Totalcount = 0;
  notifycount = 0;
  notifies = [];
  approvalcount = '0';
  approval = [];

  responseData: any;
  exporttype = [];
  constructor(
    private snackBar: MatSnackBar,
    public http: HttpClient,
    public storage: Storage,
    public dialog: MatDialog,
    public sanitizer: DomSanitizer,
    public connection: ConnectionService,
    public router: Router
  ) {
    this.connection.networkStatus();
    this.storage.get('token').then((val) => {
      if (val !== null) {
        this.token = val;
      }
    });
  }
  getAuthResponse() {
    this.storage.get('authorizationResponse').then((val) => {
      if (val) {
        this.authorizationResponse = val;
        this.fycode = val.finyear
      }
    });
    this.storage.get('selectedBranch').then((val) => {
      if (val) {
        this.selectedBranch = val;
        this.brcode = val.branchcode;
      }
    });
  }
  getAuthorizationkey() {
    this.storage.get('authorizationkey').then((val) => {
      if (val) {
        this.authorizationkey = val;
      }
    });
  }
  openAlert(val) {
    if (val.Status === 'true' || val.Status === true) {
      this.configSuccess.panelClass = 'bg-accent';
    } else {
      this.configSuccess.panelClass = 'bg-warn';
    }
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: {
        message: val.Message,
        button: true
      },
      ...this.configSuccess
    });
  }
  openAlertFalse(val) {
    this.configSuccess.panelClass = 'bg-warn';
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: {
        message: val,
        button: true
      },
      ...this.configSuccess
    });
  }

  openWarningAlert(val) {
    if (val.Status === 'true' || val.Status === true) {

    } else {
      this.configSuccess.panelClass = 'bg-yellow';
    }
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: {
        message: val.Message,
        button: true
      },
      ...this.configSuccess
    });
  }

  getToken() {
    this.storage.get('token').then((token) => {
      if (token !== null) {
        this.token = token;
      }
    });
  }

  getData(path) {
    return new Promise((resolve, reject) => {
      const header = new HttpHeaders(
        { Authorization: 'Basic ' + this.token }
      );
      this.http.get(this.apiUrl + 'api/' + path, { headers: header })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          // this.errorResponse(err);
          reject(err);
        });

    });
  }
  postData(path, credentials) {
    return new Promise((resolve, reject) => {
      const header = new HttpHeaders(
        { Authorization: 'Basic ' + this.token }
      );
      this.http.post(this.apiUrl + 'api/' + path, credentials, { headers: header })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });

    });
  }


  postDataforReg(path: any, credentials: any ,token:any){
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders(
        { 'Authorization': 'Basic ' + token }
      );
      this.http.post(this.apiUrl + 'api/' + path, credentials, { headers: headers })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });

    });
  }

  postFile(path, credentials) {
    return new Promise((resolve, reject) => {
      const header = new HttpHeaders(
        { Authorization: 'Basic ' + this.token },
      );
      this.http.post(this.apiUrl + path, credentials, { headers: header })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });

    });
  }

  putData(path, credentials) {
    return new Promise((resolve, reject) => {
      const header = new HttpHeaders(
        { Authorization: 'Basic ' + this.token }
      );
      this.http.put(this.apiUrl + 'api/' + path, credentials, { headers: header })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });

    });
  }
  deleteData(path) {
    return new Promise((resolve, reject) => {
      const header = new HttpHeaders(
        { Authorization: 'Basic ' + this.token }
      );
      this.http.delete(this.apiUrl + 'api/' + path, { headers: header })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });

    });
  }

  image(path) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders(
        { 'Authorization': 'Basic ' + this.token }
      );
      return this.http.get(this.apiUrl + 'api/' + path,
        { headers: headers, responseType: 'blob' })
        .subscribe(res => {
          const resp = new Blob([res]);
          const url = window.URL;
          this.companyLogo = this.sanitizer.bypassSecurityTrustUrl(url.createObjectURL(resp));
          this.companylogoTrue = true;

        }, (err) => {
          this.companylogoTrue = false;
        });
    });
  }


  checkDayOver() {
    this.storage.get('authorizationResponse').then((val) => {
      if (val.dayoverrequired === 'YES') {
        if (val.showdayoverfirst === 'YES') {
          this.dayOverFn(val);
        }
      }
    });
  }

  async dayOverFn(val) {
    const dialogRef = this.dialog.open(AlertWindowComponent, {
      width: '350px',
      data: {
        msg: 'Day Over is not completed as on ' + val.closedayupto + '. In order to proceed you need to close the pending day over.',
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'true') {
        this.preloadTrue = true;
        const obj = { dayoverdate: val.closedayupto };
        this.putData('dayover', obj).then((success) => {
          this.openAlert(success);
          this.preloadTrue = false;
        }, (err) => {
          this.preloadTrue = false;
        });
      } else if (result === 'false') {
        dialogRef.close();
      }
    });
  }


  errorResponse(val) {
    // console.log(val);
  }

  printFormats(path) {
    const headers = new HttpHeaders(
      { 'Authorization': 'Basic ' + this.token }
    );
    return this.http.get(this.apiUrl + 'api/entryprintformats/' + path + '/preview',
      { headers: headers, responseType: 'blob' })
      .subscribe(res => {
        const resp = new Blob([res], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(resp);
        window.open(fileURL, '_blank');
      }, (err) => {

      });
  }
  printFormatsSetup(path, val) {
    const headers = new HttpHeaders(
      { 'Authorization': 'Basic ' + this.token }
    );
    return this.http.get(this.apiUrl + 'api/entryprintformats/' + path + '/preview',
      { headers: headers, responseType: 'blob' })
      .subscribe(res => {
        const resp = new Blob([res], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(resp);
        window.open(fileURL, '_blank');
      }, (err) => {
      });
  }

  download(path, filename) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders(
        { 'Authorization': 'Basic ' + this.token }
      );
      this.http.get(this.apiUrl + 'api/' + path, { headers: headers, responseType: 'blob' })
        .subscribe(res => {
          resolve(res);
          const blob = new Blob([res], { type: 'application/pdf' });
          // const filename = 'test.jpg';
          // console.log(filename);
          fileSaver.saveAs(blob, filename);
        }, (err) => {
          // this.errorResponse(err);
          reject(err);
        });
    });
  }

  pdf(credentials) {
    const headers = new HttpHeaders(
      { Authorization: 'Basic ' + this.token }
    );
    return this.http.post(this.apiUrl + 'api/pdf', credentials,
      { headers, responseType: 'blob' })
      .subscribe(res => {
        const resp = new Blob([res], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(resp);
        window.open(fileURL, '_blank');
      }, (err) => {
      });
  }

  pdfeway(credentials) {
    const headers = new HttpHeaders(
      { Authorization: 'Basic ' + this.token }
    );
    return this.http.post(this.apiUrl + 'api/sales/ewaybill/preview', credentials,
      { headers, responseType: 'blob' })
      .subscribe(res => {
        const resp = new Blob([res], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(resp);
        window.open(fileURL, '_blank');
        const resp1 = new Blob([res], { type: 'application/json' });
        console.log(credentials);
       
        // this.openAlert(resp1);
      }, (err) => {
      });
  }

  pdfewayforSalesreturn(credentials) {
    const headers = new HttpHeaders(
      { Authorization: 'Basic ' + this.token }
    );
    return this.http.post(this.apiUrl + 'api/salesreturn/ewaybill/preview', credentials,
      { headers, responseType: 'blob' })
      .subscribe(res => {
        const resp = new Blob([res], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(resp);
        window.open(fileURL, '_blank');
        const resp1 = new Blob([res], { type: 'application/json' });
        console.log(credentials);
       
        // this.openAlert(resp1);
      }, (err) => {
      });
  }

  approveNow(now) {
    this.putData('approve', now).then((success) => {
      this.openAlert(success);
      window.location.reload();
    }, (err) => {
    });
  }

  downloadpost(path, credentials, filename) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders(
        { 'Authorization': 'Basic ' + this.token }
      );
      this.http.post(this.apiUrl + 'api/' + path, credentials, { headers: headers, responseType: 'blob' })
        .subscribe((res: any) => {
          const blob = new Blob([res]);
          let responseHeader = res.headers;
          // const contentDisposition = responseHeader.get('content-disposition');
          // console.log(contentDisposition);
          // const filename = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim(); 

          fileSaver.saveAs(blob, filename);
          resolve(res);
        }, (err) => {
          reject(err);
        });

    });
  }

  deletepostData(path, credentials) {
    return new Promise((resolve, reject) => {
      const options = {
        headers: new HttpHeaders(
          { 'Authorization': 'Basic ' + this.token }
        ),
        body: credentials
      }
      this.http.request('delete', this.apiUrl + 'api/' + path, options)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getExportType() {
    if (this.token !== '') {
      this.getData('exporttypes').then((success) => {
        this.responseData = success;
        if (this.responseData.Status === true) {
          this.exporttype = this.responseData.data;
          // if (this.responseData.data[0]) {
          //   this.menuIcon = 'more_vert'
          // } else if (this.responseData.data[1]) {
          //   this.menuIcon = 'accessibility'
          // } else if (this.responseData.data[2]) {
          //   this.menuIcon = 'accessible_forward'
          // }
          // else if (this.responseData.data[3]) {
          //   this.menuIcon = 'accessible_forward'
          // }
          // else if (this.responseData.data[4]) {
          //   this.menuIcon = 'accessible_forward'
          // }
        } else {
          this.exporttype = [];
        }
      }, (error) => {
        this.errorResponse(error);
      });
    } else {
      setTimeout(() => {
        this.getExportType();
      }, 400);
    }
  }

  matrixData() {
    if (this.token !== '') {
      this.getData('matrix/setup').then((success) => {
        this.responseData = success;
        if (this.responseData.Status === true) {
          this.matrices = this.responseData.data;
          console.log(this.matrices)
        } else {
          this.matrices = {
            matrix1: { caption: '', required: '' },
            matrix2: { caption: '', required: '' },
            matrix3: { caption: '', required: '' },
            matrix4: { caption: '', required: '' },
            matrix5: { caption: '', required: '' },
            matrix6: { caption: '', required: '' },
            matrix7: { caption: '', required: '' },
            matrix8: { caption: '', required: '' },
            matrix9: { caption: '', required: '' },
            matrix10: { caption: '', required: '' },
          };
        }
      }, (error) => {
        this.errorResponse(error);
      });
    } else {
      setTimeout(() => {
        this.matrixData();
      }, 400);
    }
  }

  ClearTokenEtc() {
    this.storage.remove('authorizationResponse');
    this.storage.remove('selectedBranch');
    this.storage.remove('isAuthorized');
    this.storage.remove('token');
    this.storage.remove('temptoken');
    this.storage.remove('authorizationkey');
    this.storage.remove('selectedFinYear');
    // Default
    // this.storage.remove('pDefaultColumn');
    // this.storage.remove('poDefaultColumn');
    // this.storage.remove('prDefaultColumn');
    // this.storage.remove('quotDefaultColumn');
    // this.storage.remove('soDefaultColumn');
    // this.storage.remove('srDefaultColumn');
    // this.storage.remove('rsDefaultColumn');
    // this.storage.remove('tsDefaultColumn');
    // this.storage.remove('salesDefaultColumn');
    // this.storage.remove('dcDefaultColumn');
    // this.storage.remove('inwardDefaultColumn');
    // this.storage.remove('opsDefaultColumn');
    // this.storage.remove('consumedpDefaultColumn');
    // this.storage.remove('producedpDefaultColumn');
    // this.storage.remove('inspectionDefaultColumn');

    this.storage.remove('copy');
    this.storage.remove('copypaste');

    this.router.navigateByUrl('/login');
  }
  ClearAllEntryDraft() {
    this.storage.remove('tsData');
    this.storage.remove('rsData');
    this.storage.remove('opsData');
    this.storage.remove('ConsumedPCData');
    this.storage.remove('ProducedPCData');

    this.storage.remove('pData');
    this.storage.remove('poData');
    this.storage.remove('prData');
    this.storage.remove('inspectionData');
    this.storage.remove('inwardData');
    this.storage.remove('supplierdcData');

    this.storage.remove('salesData');
    this.storage.remove('soData');
    this.storage.remove('srData');
    this.storage.remove('quotData');
    this.storage.remove('dcData');
    this.storage.remove('dcTicketClose');
    this.storage.remove('goodsissuedData');
    this.storage.remove('wastageData');
  }
  ClearAllDraft() {
    // Account
    this.storage.remove('FilterCashDeposit');
    this.storage.remove('FilterExpenseEntry');
    this.storage.remove('FilterAccountJournalList');
    this.storage.remove('FilterAccountPaymentList');
    this.storage.remove('FilterReceiptsList');
    this.storage.remove('payment');
    // Account report
    this.storage.remove('FilterReportAccountSchedule');
    this.storage.remove('FilterReportAccountsSummarys');
    // this.storage.remove('FilterReportAccountLedger');
    this.storage.remove('FilterReportAgewisePayables');
    this.storage.remove('FilterReportAgewiseReceivables');
    this.storage.remove('FilterReportBalanceSheetHorizontalwise');
    this.storage.remove('FilterReportBalanceSheetVerticalwise');
    this.storage.remove('FilterReportBrsLedger');
    this.storage.remove('FilterReportCashCard');
    this.storage.remove('FilterReportDaywiseBusinessSummary');
    this.storage.remove('FilterReportExpenseEntrywise');
    this.storage.remove('FilterReportGSTPurchaseAbstract');
    this.storage.remove('FilterReportGSTPurchaseDetail');
    this.storage.remove('FilterReportGSTPurchaseSummary');
    this.storage.remove('FilterReportGSTSalesAbstract');
    this.storage.remove('FilterReportGSTSalesDetail');
    this.storage.remove('FilterReportGSTSalesSummary');
    this.storage.remove('FilterReportMonthwiseBusinessSummary');
    this.storage.remove('FilterReportPandLVerticalwise');
    this.storage.remove('FilterReportPartyBillwiseBalance');
    this.storage.remove('FilterReportPartyLedgerwiseBalance');
    this.storage.remove('FilterReportPayables');
    this.storage.remove('FilterReportPayablesBillwise');
    this.storage.remove('FilterReportPaymentDeleted');
    this.storage.remove('FilterReceiptAmountWise');
    this.storage.remove('FilterReportReceiptDeleted');
    this.storage.remove('FilterReportReceiptAndPayment');
    this.storage.remove('FilterReportReceiptAndPaymentDetail');
    this.storage.remove('FilterReceiptRecivables');
    this.storage.remove('FilterReportReceivablesAreawiseSummary');
    this.storage.remove('FilterReceiptRecivablesBillwise');
    this.storage.remove('FilterReportReceivablesBranchwiseSummary');
    this.storage.remove('FilterReportReceivablesDetailCustomerwise');
    this.storage.remove('FilterReportReceivablesOpeningwiseSummary');
    this.storage.remove('FilterReportReceivablesPersonwiseSummary');
    this.storage.remove('FilterReportReceivablesStatewiseSummary');
    this.storage.remove('FilterReportCashDeposit');
    this.storage.remove('FilterReportContra');
    this.storage.remove('FilterReportVat');
    this.storage.remove('FilterReportCreditNotes');
    this.storage.remove('FilterReportDebitNotes');
    this.storage.remove('FilterReportExpenses');
    this.storage.remove('FilterReportTrailBalance');
    this.storage.remove('FilterReportTaxRegisterPurchasePartywise');
    this.storage.remove('FilterReportTaxRegisterSalesPartywise');
    this.storage.remove('FilterReportTaxRegisterSummary');
    this.storage.remove('FilterReportTaxRegisterSalesDaywise');
    this.storage.remove('FilterReportTaxRegisterSalesBillwise');
    this.storage.remove('FilterReportTaxRegisterPurchaseDaywise');
    this.storage.remove('FilterReportTaxRegisterPurchaseBillwise');
    this.storage.remove('FilterReportPandLHorizontalwise');
    this.storage.remove('FilterReportReceivablesDetailCustomerGroupwise');
    this.storage.remove('FilterReportSupplierAdvance');
    this.storage.remove('FilterReportCostCenter');
    // Settings
    this.storage.remove('FilterApprovals');
    this.storage.remove('FilterReportApproval');
    this.storage.remove('FilterReportUserActivity');
    this.storage.remove('FilterSettingsRightsProfileLists');
    // Dashboard
    // this.storage.remove('FilterLandingDashboard');
    // items
    this.storage.remove('FilterItemsList');
    this.storage.remove('tsData');
    this.storage.remove('rsData');
    this.storage.remove('ConsumedPCData');
    this.storage.remove('ProducedPCData');
    // items report
    this.storage.remove('FilterReportAgewiseStock');
    this.storage.remove('FilterReportAllRatewiseStock');
    this.storage.remove('FilterReportBarcodewiseStockAbstract');
    this.storage.remove('FilterReportBarcodewiseStockDetail');
    this.storage.remove('FilterReportBatchExpiryStock');
    this.storage.remove('FilterReportDamagedStock');
    this.storage.remove('FilterReportDatarangeStockAbstract');
    this.storage.remove('FilterReportDatarangeStockDetail');
    this.storage.remove('FilterReportDaywiseStockvalue');
    this.storage.remove('FilterReportGodownwiseStock');
    this.storage.remove('FilterReportItemRateChange');
    this.storage.remove('FilterReportMinimumMaximumStock');
    this.storage.remove('FilterReportNonmovingStock');
    this.storage.remove('FilterReportProductConversion');
    this.storage.remove('FilterReportProductConversionItementrywise');
    this.storage.remove('FilterReportProductConversionItemwise');
    this.storage.remove('FilterReportSalesStockvalue');
    this.storage.remove('FilterReportSerialNoTracking');
    this.storage.remove('FilterReportSlowmovingStock');
    this.storage.remove('FilterReportStockAbstract');
    this.storage.remove('FilterReportStockDetail');
    this.storage.remove('FilterReportStockIssuedToBranch');
    this.storage.remove('FilterReportStockQuantityWise');
    this.storage.remove('FilterReportStockRateWise');
    this.storage.remove('FilterReportStockReceivedFromBranch');
    this.storage.remove('FilterReportStockRequestFromBranch');
    this.storage.remove('FilterReportStockinItemwise');
    this.storage.remove('FilterReportStockoutItemwise');
    this.storage.remove('FilterReportStoreLedger');
    // items Settings
    this.storage.remove('FilterSettingBranchwiseStockBasedRateSetup');
    this.storage.remove('FilterSettingItemDiscountBulkSetup');
    this.storage.remove('FilterSettingItemPriceBulkSetup');
    // Other
    this.storage.remove('FilterReportDocumentTracking');
    this.storage.remove('pricelist');
    // Purchase
    this.storage.remove('inwardData');
    this.storage.remove('inwardinspectionpending');
    this.storage.remove('inspectionData');
    this.storage.remove('opsData');
    this.storage.remove('pData');
    this.storage.remove('poData');
    this.storage.remove('prData');
    this.storage.remove('supplierdcData');
    this.storage.remove('FGEinspectionpending');
    // this.storage.remove('supplierdcDefaultColumn');
    // Purchase Report
    this.storage.remove('FilterReportDaywisePurchasevalue');
    this.storage.remove('FilterReportGoodsInwardAbstract');
    this.storage.remove('FilterReportGoodsInwardDetail');
    this.storage.remove('FilterReportIndentDetails');
    this.storage.remove('FilterReportIndent');
    this.storage.remove('FilterReportIndentPending');
    this.storage.remove('FilterReportInwardInspectionAbstract');
    this.storage.remove('FilterReportInwardInspectionItemwise');
    this.storage.remove('FilterReportInwardInspectionPending');
    this.storage.remove('FilterReportInwardInspectionPendingDetail');
    this.storage.remove('FilterReportInwardPending');
    this.storage.remove('FilterReportItemTobeReceivedFromsupplier');
    this.storage.remove('FilterReportOpeningStocksAbstract');
    this.storage.remove('FilterReportOpeningstock');
    this.storage.remove('FilterReportOpeningStockBatchwise');
    this.storage.remove('FilterReportPOAbstract');
    this.storage.remove('FilterReportPoGroupwiseSummary');
    this.storage.remove('FilterReportPoItemwise');
    this.storage.remove('FilterReportPoMakewiseSummary');
    this.storage.remove('FilterReportPoPendingAbstract');
    this.storage.remove('FilterReportPoPendingDetail');
    this.storage.remove('FilterReportPoReportDetail');
    this.storage.remove('FilterReportPoSummarySupplierwise');
    this.storage.remove('FilterReportPurchaseBillWise');
    this.storage.remove('FilterReportPurchaseDeletedAbstract');
    this.storage.remove('FilterReportPurchaseDeletedDetail');
    this.storage.remove('FilterReportPurchaseDetail');
    this.storage.remove('FilterReportPurchaseGroupwiseSummary');
    this.storage.remove('FilterReportPurchaseItemQuantitywise');
    this.storage.remove('FilterReportPurchaseItemValueWise');
    this.storage.remove('FilterReportPurchaseItemwiseWithtax');
    this.storage.remove('FilterReportPurchaseReportMovement');
    this.storage.remove('FilterReportPurchaseReturnBillWise');
    this.storage.remove('FilterReportPurchaseReturnDetail');
    this.storage.remove('FilterReportPurchaseReturnItemWise');
    this.storage.remove('FilterReportPurchaseSummarySupplierwise');
    this.storage.remove('FilterReportSupplierDcAbstract');
    this.storage.remove('FilterReportSupplierDcItemwise');
    this.storage.remove('FilterReportSupplierdcGRNPendings');
    this.storage.remove('FilterReportSuppliersPurchasePayables');
    // Sales
    this.storage.remove('dcData');
    this.storage.remove('dcTicketClose');
    this.storage.remove('FilterOrderCompletedList');
    this.storage.remove('FilterOrder');
    this.storage.remove('soData');
    this.storage.remove('quotData');
    this.storage.remove('salesData');
    this.storage.remove('srData');
    this.storage.remove('goodsissuedData');
    // this.storage.remove('goodsissuedDefaultColumn');
    this.storage.remove('wastageData');
    // this.storage.remove('wastageDefaultColumn');
    // Sales Order Report
    this.storage.remove('FilterReportOrderAmountWise');
    this.storage.remove('FilterReportOrderItemWise');
    this.storage.remove('FilterReportOrderPendingItemWise');
    this.storage.remove('FilterReportOrderPendingStock');
    this.storage.remove('FilterReportSoCustomerwiseSummary');
    this.storage.remove('FilterReportSoDetails');
    this.storage.remove('FilterReportSoGroupwiseSummary');
    this.storage.remove('FilterReportSoMakewiseSummary');
    this.storage.remove('FilterReportSoPendingAbstract');
    this.storage.remove('FilterReportSoPendingDetail');
    // Sales Report
    this.storage.remove('FilterReportCheque');
    this.storage.remove('FilterReportCollectionBankwiseAbstract');
    this.storage.remove('FilterReportCollectionBankwiseDetail');
    this.storage.remove('FilterReportCollectionBranchwiseSummary');
    this.storage.remove('FilterReportCollectionBtwiseAbstract');
    this.storage.remove('FilterReportCollectionBtwiseDetail');
    this.storage.remove('FilterReportCollectionCardwiseAbstract');
    this.storage.remove('FilterReportCollectionCardwiseDetail');
    this.storage.remove('FilterReportCollectionChequewiseAbstract');
    this.storage.remove('FilterReportCollectionChequewiseDetail');
    this.storage.remove('FilterReportCollectionCounterwiseSummary');
    this.storage.remove('FilterReportCollectionCustomerwiseAbstract');
    this.storage.remove('FilterReportCollectionCustomerwiseDetail');
    this.storage.remove('FilterReportCollectionDdwiseAbstract');
    this.storage.remove('FilterReportcollectionreceiptentry');
    this.storage.remove('FilterReportCollectionDdwiseDetail');
    this.storage.remove('FilterReportCollectionReceipttypewiseSummary');
    this.storage.remove('FilterReportCollectionUserwiseSummary');
    this.storage.remove('FilterReportCounterSettlement');
    this.storage.remove('FilterReportCoupenIssuedAbstract');
    this.storage.remove('FilterReportCoupenIssuedDetail');
    this.storage.remove('FilterReportCustomerAdvance');
    this.storage.remove('FilterReportCustomerLastVisit');
    this.storage.remove('FilterReportCustomerPropertyWithUs');
    this.storage.remove('FilterReportDayResult');
    this.storage.remove('FilterReportDaywiseSalesvalue');
    this.storage.remove('FilterReportDcAbstract');
    this.storage.remove('FilterReportDcDetail');
    this.storage.remove('FilterReportDcItemwise');
    this.storage.remove('FilterReportDcStock');
    this.storage.remove('FilterReportDcStockDetails');
    this.storage.remove('FilterReportGodownTransfer');
    this.storage.remove('FilterReportGoodsIssuedAbstract');
    this.storage.remove('FilterReportGoodsIssuedDetail');
    this.storage.remove('FilterReportHoldSalesAbstract');
    this.storage.remove('FilterReportHoldSalesDetail');
    this.storage.remove('FilterReportSalesHourwiseReceipttypewise');
    this.storage.remove('FilterReportItemDeliveredCustomer');
    this.storage.remove('FilterReportQuotationAbstract');
    this.storage.remove('FilterReportQuotationDetail');
    this.storage.remove('FilterReportRewardAbstract');
    this.storage.remove('FilterReportRewardDetail');
    this.storage.remove('FilterReportRoundoffDaywiseSummary');
    this.storage.remove('FilterReportRoundoffEntrywiseSummary');
    this.storage.remove('FilterReportSalesActualCostComparision');
    this.storage.remove('FilterReportSalesAndCancelled');
    this.storage.remove('FilterReportSalesAreawiseSummary');
    this.storage.remove('FilterReportSalesBaseReminder');
    this.storage.remove('FilterReportSalesBillWise');
    this.storage.remove('FilterReportSalesBranchwiseSummary');
    this.storage.remove('FilterReportSalesCardwise');
    this.storage.remove('FilterReportSalesCounterwiseSummary');
    this.storage.remove('FilterReportSalesCoupenAbstract');
    this.storage.remove('FilterReportSalesCoupenDetail');
    this.storage.remove('FilterReportSalesCustomerwiseSummary');
    this.storage.remove('FilterReportSalesDaywiseReceipttypewise');
    this.storage.remove('FilterReportSaleswithvaluesummary');
    this.storage.remove('FilterReportSalesDeletedAbstract');
    this.storage.remove('FilterReportSalesDeletedDetail');
    this.storage.remove('FilterReportSalesDetails');
    this.storage.remove('FilterReportSalesGroupwiseSummary');
    this.storage.remove('FilterReportSalesItemWise');
    this.storage.remove('FilterReportSalesMakewiseSummary');
    this.storage.remove('FilterReportSalesPersonwiseSummary');
    this.storage.remove('FilterReportSalesReceiptTypewise');
    this.storage.remove('FilterReportSalesReturnAbstract');
    this.storage.remove('FilterReportSalesReturnDetail');
    this.storage.remove('FilterReportSalesSettlement');
    this.storage.remove('FilterReportSalesStatewiseSummary');
    this.storage.remove('FilterReportSalesSupplierwiseItemSummary');
    this.storage.remove('FilterReportSalesTaxQtySummary');
    this.storage.remove('FilterReportSalesPersonCommissionBillwise');
    this.storage.remove('FilterReportSalesPersonCommissionItemwise');
    this.storage.remove('FilterReportSalesPersonTarget');
    this.storage.remove('FilterReportSalespersonWiseCommission');
    this.storage.remove('FilterReportSalesprofitAnalysisCostcenterwise');
    this.storage.remove('FilterReportSalesprofitAnalysisCounterwise');
    this.storage.remove('FilterReportSalesprofitAnalysisCustomerwise');
    this.storage.remove('FilterReportSalesprofitAnalysisGroupwise');
    this.storage.remove('FilterReportSalesprofitAnalysisPersonwise');
    this.storage.remove('FilterReportSalesprofitAnalysisProductwise');
    this.storage.remove('FilterReportSalesprofitAnalysisSalesbillwise');
    this.storage.remove('FilterReportSalesprofitAnalysisSupplierwise');
    this.storage.remove('FilterReportTopSales');
    this.storage.remove('FilterReportWastageAbstract');
    this.storage.remove('FilterReportWastageDetail');

    // Production Report
    this.storage.remove('FilterReportBOMAbstract');
    this.storage.remove('FilterReportFGEInspectionPendings');
    this.storage.remove('FilterReportFinishedGoodsAbstract');
    this.storage.remove('FilterReportFinishedGoodsInspectionAbstract');
    this.storage.remove('FilterReportGoodsIssueReturnAbstract');
    this.storage.remove('FilterReportMRNAbstract');
    this.storage.remove('FilterReportProductionOrder');
    this.storage.remove('FilterReportBOMDetail');
    this.storage.remove('FilterReportFGIDetail');
    this.storage.remove('FilterReportWOAbstract');
    // this.router.navigateByUrl('/login');
  }



  // START - APPROVAL //


  getApprovalCount() {
    if (this.token !== '') {
      this.getData('approvalwaitings/count').then((success) => {
        this.responseData = success;
        this.getNotifyCount();
        if (this.responseData.Status === true) {
          if (this.approvalcount !== this.responseData.approvalwaitingscount) {
            this.getApproval();
          }
          this.approvalcount = this.responseData.approvalwaitingscount;
          this.Totalcount = Number(this.approvalcount) + Number(this.notifycount);
          // setTimeout(() => {
          //   this.getApprovalCount();
          // }, 60000);
        } else {
          this.approvalcount = '0';
          this.Totalcount = Number(this.approvalcount) + Number(this.notifycount);
        }
      }, (error) => {
        this.errorResponse(error);
      });
    } else {
      setTimeout(() => {
        this.getApprovalCount();
      }, 500);
    }
  }
  getNotifyCount() {
    if (this.token !== '') {
      this.getData('notifications/count').then((success) => {
        this.responseData = success;
        setTimeout(() => {
          this.getApprovalCount();
        }, 300000);
        if (this.responseData.Status === true) {
          if (this.notifycount !== this.responseData.notificationcount) {
            this.getNotify();
          }
          this.notifycount = this.responseData.notificationcount;
          this.Totalcount = Number(this.approvalcount) + Number(this.notifycount);
        } else {
          this.notifycount = 0;
          this.Totalcount = Number(this.approvalcount) + Number(this.notifycount);
        }
      }, (error) => {
        this.errorResponse(error);
      });
    } else {
      setTimeout(() => {
        this.getNotifyCount();
      }, 500);
    }
  }
  getApproval() {
    const obj = {
      fromdate: '',
      todate: '',
      entrytype: '',
      preparedby: '',
    };
    this.postData('approvalwaitings', obj).then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.approval = this.responseData.data;
      } else { }
    }, (error) => {
      // this.btnClicked = false;
      this.errorResponse(error);
    });
  }
  getNotify() {
    const obj = {
      fromdate: '',
      todate: '',
      onlypending: '',
    };
    this.postData('notifications', obj).then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.notifies = this.responseData.data;
      } else { }
    }, (error) => {
      // this.btnClicked = false;
      this.errorResponse(error);
    });
  }
  gotoPage(val) {
    if (val.entrytype === 'Quotation') {
      this.router.navigateByUrl('home/sales/quotation/details/' + val.entryno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'SaleOrder') {
      this.router.navigateByUrl('home/sales/order/details/' + val.entryno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'Sales') {
      this.router.navigateByUrl('home/sales/details/' + val.entryno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'ServiceContract') {
      // this.router.navigateByUrl('home/sales/order/details/' + val.entryno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'Customer') {
      this.router.navigateByUrl('home/sales/customer-details/' + val.entryno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'Supplier') {
      this.router.navigateByUrl('home/purchase/supplier/supplier-details/' + val.entryno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'Product') {
      this.router.navigateByUrl('home/items/item-details/' + val.entryno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'DC') {
      this.router.navigateByUrl('home/sales/dc/details/' + val.entryno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'BranchSales') {
      this.router.navigateByUrl('home/items/stock-transfer-details/' + val.entryno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'SalesReturn') {
      this.router.navigateByUrl('home/sales/return/details/' + val.entryno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'Purchase') {
      this.router.navigateByUrl('home/purchase/purchase-details/' + val.entryno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'PurchaseOrder') {
      this.router.navigateByUrl('home/purchase/po/details/' + val.entryno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'Inward') {
      this.router.navigateByUrl('home/purchase/inward-detail/' + val.entryno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'PurchaseReturn') {
      this.router.navigateByUrl('home/purchase/purchase-return/details/' + val.entryno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'SupplierDC') {
      this.router.navigateByUrl('home/purchase/supplier-dc-details/' + val.entryno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'BranchPurchase') {
      this.router.navigateByUrl('home/items/receivestock-details/' + val.entryno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'Receipt') {
      this.router.navigateByUrl('home/accounts/receipt-details/' + val.entryno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'Payment') {
      this.router.navigateByUrl('home/accounts/payment-details/' + val.entryno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'Journal') {
      this.router.navigateByUrl('home/accounts/journal-details/' + val.entryno + '/' + this.fycode + '/' + this.brcode);
    }
  }
  gotoNotifyPage(val) {
    if (val.entrytype === 'Quotation') {
      this.router.navigateByUrl('home/sales/quotation/details/' + val.basedonno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'SaleOrder') {
      this.router.navigateByUrl('home/sales/order/details/' + val.basedonno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'Sales') {
      this.router.navigateByUrl('home/sales/details/' + val.basedonno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'ServiceContract') {
      // this.router.navigateByUrl('home/sales/order/details/' + val.basedonno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'Customer') {
      this.router.navigateByUrl('home/sales/customer-details/' + val.basedonno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'Supplier') {
      this.router.navigateByUrl('home/purchase/supplier/supplier-details/' + val.basedonno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'Product') {
      this.router.navigateByUrl('home/items/item-details/' + val.basedonno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'DC') {
      this.router.navigateByUrl('home/sales/dc/details/' + val.basedonno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'BranchSales') {
      this.router.navigateByUrl('home/items/stock-transfer-details/' + val.basedonno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'SalesReturn') {
      this.router.navigateByUrl('home/sales/return/details/' + val.basedonno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'Purchase') {
      this.router.navigateByUrl('home/purchase/purchase-details/' + val.basedonno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'PurchaseOrder') {
      this.router.navigateByUrl('home/purchase/po/details/' + val.basedonno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'Inward') {
      this.router.navigateByUrl('home/purchase/inward-detail/' + val.basedonno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'PurchaseReturn') {
      this.router.navigateByUrl('home/purchase/purchase-return/details/' + val.basedonno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'SupplierDC') {
      this.router.navigateByUrl('home/purchase/supplier-dc-details/' + val.basedonno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'BranchPurchase') {
      this.router.navigateByUrl('home/items/receivestock-details/' + val.basedonno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'Receipt') {
      this.router.navigateByUrl('home/accounts/receipt-details/' + val.basedonno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'Payment') {
      this.router.navigateByUrl('home/accounts/payment-details/' + val.basedonno + '/' + this.fycode + '/' + this.brcode);
    } else if (val.entrytype === 'Journal') {
      this.router.navigateByUrl('home/accounts/journal-details/' + val.basedonno + '/' + this.fycode + '/' + this.brcode);
    }
  }
  ClearNotificatonCount(val) {
    const obj = { notificationcode: val }
    this.putData('mark_as_notified', obj).then((result) => {
      this.responseData = result;
      if (this.responseData.Status === true) {
        this.notifycount = Number(this.notifycount) - 1;
        this.Totalcount = Number(this.approvalcount) + Number(this.notifycount);
        this.getNotifyCount();
      } else { this.openAlert(this.responseData); }
    }, (err) => {
      // console.log(err);
    });
  }
  getOnlyApprovalCount() {
    if (this.token !== '') {
      this.getData('approvalwaitings/count').then((success) => {
        this.responseData = success;
        if (this.responseData.Status === true) {
          if (this.approvalcount !== this.responseData.approvalwaitingscount) {
            this.getApproval();
          }
          this.approvalcount = this.responseData.approvalwaitingscount;
          this.Totalcount = Number(this.approvalcount) + Number(this.notifycount);
        } else {
          this.approvalcount = '0';
          this.Totalcount = Number(this.approvalcount) + Number(this.notifycount);
        }
      }, (error) => {
        this.errorResponse(error);
      });
    } else {
      setTimeout(() => {
        this.getApprovalCount();
      }, 500);
    }
  }

  removingSpace(event) {
    if (event.which === 32) {
      event.preventDefault();
    }
  }

  removingSingleQuote(event) {
    if (event.which === 39) {
      event.preventDefault();
    }
  }

  // START - page Size //
  pageSize(total) {
    // parseFloat(total)
    // const size = [10, 20, 30, 50, 100, total.toString()];
    const size = [];
    size.push(10);
    if (20 < total.toString()) {
      size.push(20);
      if (30 < total.toString()) {
        size.push(30);
        if (50 < total.toString()) {
          size.push(50);
          if (100 < total.toString()) {
            size.push(100);
            size.push(total.toString());
            return size;
          } else { size.push(total.toString()); return size; }
        } else { size.push(total.toString()); return size; }
      } else { size.push(total.toString()); return size; }
    } else {
      if (10 === total.toString()) {
        return size;
      } else { size.push(total.toString()); return size; }
    }
  }

  // START - Sales Alert Periodically Required //

  getSalesPeriodicSMSRepeated() {
    if (this.token !== '') {
      console.log(this.authorizationResponse.softwaresetup.data.salessmsalertperiodically)
      if (this.authorizationResponse.softwaresetup.data.salessmsalertperiodically === 'YES') {
        this.getSalesPeriodicSMSOnce();
        // if(Number(this.authorizationResponse.softwaresetup.data.salessmsalertperiodicalinterval) > 15) {
        // } else {}
        setTimeout(() => {
          this.getSalesPeriodicSMSRepeated();
        }, Number(this.authorizationResponse.softwaresetup.data.salessmsalertperiodicalinterval) * 60000);
        // if (this.authorizationResponse.softwaresetup.data.salessmsalertperiodicallymobileno === '') {}
      }
    } else {
      setTimeout(() => {
        this.getSalesPeriodicSMSRepeated();
      }, 500);
    }
  }
  getSalesPeriodicEmailRepeated() {
    if (this.token !== '') {
      if (this.authorizationResponse.softwaresetup.data.salesemailalertperiodically === 'YES') {
        this.getSalesPeriodicEmailOnce();
        setTimeout(() => {
          this.getSalesPeriodicEmailRepeated();
          // setTimeout(() => {  }, 1000);
        }, Number(this.authorizationResponse.softwaresetup.data.salesemailalertperiodicalinterval) * 60000);
        // if (this.authorizationResponse.softwaresetup.data.salesemailalertperiodicallymailid === '') {}
      }
    } else {
      setTimeout(() => {
        this.getSalesPeriodicEmailRepeated();
      }, 500);
    }
    // this.Totalcount = Number(this.approvalcount) + Number(this.notifycount);
  }
  getSalesPeriodicSMSOnce() {
    if (this.token !== '') {
      if (this.authorizationResponse.softwaresetup.data.salessmsalertperiodically === 'YES') {
        this.getData('send/sms/salesperiodic').then((success) => { }, (error) => { });
      }
    } else {
      setTimeout(() => {
        this.getSalesPeriodicSMSOnce();
      }, 500);
    }
  }
  getSalesPeriodicEmailOnce() {
    if (this.token !== '') {
      if (this.authorizationResponse.softwaresetup.data.salesemailalertperiodically === 'YES') {
        this.getData('send/email/salesperiodic').then((success) => { }, (error) => { });
      }
    } else {
      setTimeout(() => {
        this.getSalesPeriodicEmailOnce();
      }, 500);
    }
  }

  getPrintPreview(id) {
    const obj = {
      refnumber: id,
      useractioncodes: ["6", "8"],
      sortby: 'actiondate',
      sorttype: 'desc'
    };

    this.postData('reports/useractivity', obj).then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.printPreview = this.responseData.data;
        this.printPreviewDetails = this.responseData.data[0];
      } else {
        this.printPreview = [];
        this.clearPrintPreviewDetails();
      }
    });
  }

  clearPrintPreviewDetails() {
    this.printPreviewDetails = {
      'actiondate': '',
      'refno': '',
      'formname': '',
      'actiontype': '',
      'username': ''
    }
  }

}
